import React, { useContext, useEffect, useState } from "react";
import styles from './style.module.css';
import useStore from "../../store/store";
import SweetAlert from "../../Components/SweetAlert";
import serverPath from "../../utils/serverPath";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import AskAlert from "../../utils/AskAlert";
import deleteOne from "../../utils/deleteOne";

const UpdateCurrencyRate = (props) =>
{
  const {id} = useParams();
    
  const navigate = useNavigate()
  const [globalState, dispatch] = useStore();
  const {currencies, currencyRates} = globalState;
  const [isLoading, setIsLoading] = useState(false);

  const initialFields = {
    buy: 0,
    sell: 0,
    province: "",
  };
  const [fields, setFields] = useState({...initialFields});
  let provinces = ["Kabul", "Kandahar", "Herat", "Mazar-i-Sharif", "Jalalabad"];
  
  const changeHandler = (e, type) =>
  {
    setFields(prev => ({...prev, [type]: e.target.value}))
  };

  useEffect(() =>
  {
    (async() => {

      const find = currencyRates.find(rate => rate.id == id)

      if(!(find?.id))
        navigate("/currencyRate", {replace: true})   

      if(find?.id)
        setFields({buy: find.buy, sell: find.sell, province: find.province});
      window.loadForm();
    })()
  }, [id])


  const submitHandler = async (e) =>
  {
      e.preventDefault();
      if(isLoading)
        return;
      
      try {
        const { buy, sell, province } = fields;

        if ((buy > 0 && (!sell || sell === 0)) || (sell > 0 && (!buy || buy === 0)))
          return SweetAlert("warning", `Apply condition for ${province}`);
        if (!province || province.length <= 0)
          return SweetAlert("warning", `Province is required`);

        setIsLoading(true);
        const {data : objData} = await axios.put(
          serverPath("/currency_rate"), 
          {...fields, id},
          {headers: {
            "Authorization": `bearer ${localStorage.getItem("A_TOKEN")}`
          }}
        )
          
        setIsLoading(false);
        if(objData.status === "failure")
          return SweetAlert('error', objData.message);
      
        console.log(objData, "objData");
        
        const updateCurrencyRate = objData.data;
        const clone = [...currencyRates];
        let index  = clone.findIndex(per => per.id == id)
        if(index >= 0)
        {
          clone[index] = { ...updateCurrencyRate};
          dispatch('setData', {type: 'currencyRate', data: clone});
        }
        
        return SweetAlert('success',"Currency Rate Successfully updated!").then(res => navigate('/currencyRate', {replace: true}));
  
  
      } catch (error) {
        return SweetAlert("error", error.message);
      }
    }


    const deleteHandler = async (e) =>
    {
      e.preventDefault();
      if(isLoading)
        return;
        
      let sure = await AskAlert({text: "Sure to delete this currency rate!"})
      if(!sure)
        return;
      setIsLoading(true);  
      const {status, message} = await deleteOne('currency_rate', id);
      setIsLoading(false);
      if(status === 'success')
      {
        const newRates = [...currencyRates];
        let index = newRates.findIndex(per => per.id == id);
        if(index >= 0)
        {
          newRates.splice(index, 1);
          dispatch('setData', {type: 'currencyRates', data: newRates});
          SweetAlert('success', "Successfully Deleted");
        }
        navigate('/currencyRate', {replace: true});
      }
      if(status === 'failure')
      {
        SweetAlert("error", message);
      }
    }

    return (
      <div className="main-content">
      <section className="section">
        <div className="section-body">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4>Update Currency Rate</h4>
                </div>
                <form onSubmit={submitHandler}>
                  <div className="card-body">
                    <div className="form-group row mb-4">
                      <label className="col-form-label text-md-right col-12 col-md-3 col-lg-3">Buy</label>
                      <div className="col-sm-12 col-md-7">
                        <input type="number" className="form-control"placeholder="Must Be Numeric Value" required value={fields.buy} onChange={(e) => changeHandler(e, "buy")}/>
                      </div>
                    </div>
                    <div className="form-group row mb-4">
                      <label className="col-form-label text-md-right col-12 col-md-3 col-lg-3">Sell</label>
                      <div className="col-sm-12 col-md-7">
                        <input type="number" className="form-control"placeholder="Must Be Numeric Value" required value={fields.sell} onChange={(e) => changeHandler(e, "sell")}/>
                      </div>
                    </div>
                    <div className="form-group row mb-4">
                      <label className="col-form-label text-md-right col-12 col-md-3 col-lg-3">Province</label>
                      <div className="col-sm-12 col-md-7">
                        <select className="form-control" value={fields.province} onChange={(e) => changeHandler(e, "province")}>
                          <option value={fields.province}>{fields.province}</option>
                          {provinces.map(province => (
                            <option value={province} key={province} disabled={fields.province === province}>{province}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group row mb-4">
                      <label className="col-form-label text-md-right col-12 col-md-3 col-lg-3"></label>
                      <div className="col-sm-12 col-md-7">
                        <button className={["btn btn-primary", isLoading ? "btn-progress" : ""].join(" ")} onClick={submitHandler} disabled={isLoading}>Save Currency Rate</button>
                        <button className={["btn btn-danger float-right", isLoading ? "btn-progress" : ""].join(" ")} onClick={deleteHandler} disabled={isLoading}>Delete Currency Rate</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    )
}


export default UpdateCurrencyRate;